/** Cart Gateway Elements */
const checkoutBtn = document.querySelector("[name='checkout']"); //Standard Checkout Button
const errorMsg = document.querySelector('.cart-gateway__form-fail');
const ageFields = document.querySelectorAll('.cart-gateway__form-field');

const gatewayPopup = document.querySelector('[data-gateway-popup]');
const gatewayBtn = document.querySelector('[data-gateway-validate]');
const DOBContainer = document.querySelector('[data-gateway-date-form-wrapper]');

/** Age Elements */
const userYear = document.querySelector('[data-dob-year]');
const userMonth = document.querySelector('[data-dob-month]');
const userDay = document.querySelector('[data-dob-day]');

/** Cart Consent Popup */
const calculateAge = (DOBString) => {
  const today = new Date();
  const currentYear = today.getFullYear();
  let currentMonth = today.getMonth(); currentMonth++;
  const currentDay = today.getDate();
  const dob = new Date(DOBString);

  const birthYear = dob.getFullYear();
  let birthMonth = dob.getMonth(); birthMonth++;
  const birthDay = dob.getDate();
  let age = currentYear - birthYear;

  if (birthMonth > currentMonth) {
    age--;
  } else if (birthMonth == currentMonth && birthDay > currentDay) {
    age--;
  }
  return age;
};

/** Allow keyboard manipulation for date changes */
DOBContainer.addEventListener('keyup', (e) => {
  errorMsg.classList.remove('show');
  let target = e.srcElement;
  let maxLength = parseInt(target.attributes['maxlength'].value, 4);
  let length = target.value.length;
  if (length >= maxLength) {
    var next = target;
    while (next = next.nextElementSibling) {
      if (next == null)
        break;
      if (next.tagName.toLowerCase() == "input") {
        next.focus();
        break;
      }
    }
  }

});

/** Cart checkout button shows age verification popup */
checkoutBtn.addEventListener('click', (e) => {
    e.preventDefault();
    document.querySelector('.cart-menu-close').click();
    gatewayPopup.setAttribute("style", "display:flex");
});

/** Validate age and allow customer through to checkout if over 18 */
gatewayBtn.addEventListener('click', (e) => {
  e.preventDefault();

  const userDOB = `${userYear.value}-${userMonth.value}-${userDay.value}`;
  const customerAge = calculateAge(userDOB);

  const dobFieldArray = [...ageFields];
  let ageError = false;
  dobFieldArray.forEach(field => {
    if (field.value == "" || field.value == null) {
        ageError = true;
    }
  })

  if (isNaN(customerAge) || ageError) {
    errorMsg.classList.add('show');
  } else if (customerAge >= 18) {
    gatewayPopup.setAttribute("style", "none");
    const custDOB = new Date(userDOB);
    const dobMonth = custDOB.toLocaleString('default', { month: 'long' });
    
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          'Age Verification Status': 'Verified',
          'DOB': `${custDOB.getDate()} ${dobMonth} ${userYear.value} (${userYear.value}-${userMonth.value}-${userDay.value})`
        }
      })
    })
    .then(response => response.json())
    .then(document.location = '/checkout');
  } else if (customerAge < 18) {
    setTimeout(() => {
      document.location = 'https://drinkwise.org.au';
    }, 250);
  } else {
    errorMsg.classList.add('show');
  }
});